const Mailto = ({ email, subject, body = '', children }) => {

    let params = subject || body ? '?' : '';
    if (subject) params += `subject=${encodeURIComponent(subject)} `;
    if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

    return <a href={`mailto:${email}${params}`} style={{ fontWeight: 700, color: "rgb(7,121,131)" }}>{children}</a>;
};

export default Mailto